import React, { useEffect, useState } from 'react'
import { Box, IconButton, Typography } from '@mui/material'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const sectionStyle = {
  width: '100%',
  pt: 1,
  pl: 1,
  mb: 1,
}

function PlanTableHeaderSection({ children, isV3 = false }) {
  const storedTableHeaderVisibility = JSON.parse(localStorage.getItem('showPlanTableHeaderSection'))
  const [showTableHeaderSection, setShowTableHeaderSection] = useState(
    storedTableHeaderVisibility === null ? true : storedTableHeaderVisibility,
  )

  useEffect(() => {
    localStorage.setItem('showPlanTableHeaderSection', JSON.stringify(showTableHeaderSection))
  }, [showTableHeaderSection])

  return (
    <Box sx={sectionStyle} className={isV3 ? 'v3-plan-page__callout' : undefined}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: showTableHeaderSection && children ? 1 : 0,
        }}
      >
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          Table Header
        </Typography>
        <IconButton
          aria-label={showTableHeaderSection ? 'Hide table header section' : 'Show table header section'}
          data-testid="plan-table-header-toggle"
          onClick={() => setShowTableHeaderSection(currentValue => !currentValue)}
          size="small"
        >
          {showTableHeaderSection ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>
      {showTableHeaderSection ? children : null}
    </Box>
  )
}

export default PlanTableHeaderSection

